module.exports = {
  TIME_RANGE_BASED: 'time-range-based',
  STANDARD: 'standard',
};
